module.exports = __webpack_public_path__ + "img/submit_car.19f6f8b0.png";